// SavedViews — dropdown + save-current.

import { useState } from "react";
import { Icon } from "@/lib/icons";
import { cn } from "@/lib/cn";
import type { BrowseView } from "@/store/browse";

export interface SavedViewsProps {
  views: BrowseView[];
  current?: string;
  onApply: (id: string) => void;
  onSave: (name: string) => void;
  onDelete?: (id: string) => void;
}

export function SavedViews({ views, current, onApply, onSave, onDelete }: SavedViewsProps) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const active = views.find(v => v.id === current);
  return (
    <div className="lex-popover-wrap">
      <button
        type="button"
        className="lex-toolbar-btn"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Icon.Tag size={14} aria-hidden="true" />
        <span>{active?.name ?? "Views"}</span>
        <Icon.ChevronDown size={14} aria-hidden="true" />
      </button>
      {open ? (
        <>
          <div className="lex-popover-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="lex-popover" role="menu">
            <div className="lex-popover__heading">Saved views</div>
            {views.length === 0 ? (
              <div className="lex-popover__empty">No saved views yet.</div>
            ) : views.map(v => (
              <div key={v.id} className={cn("lex-popover__row", v.id === current && "lex-popover__row--active")}>
                <button
                  type="button"
                  className="lex-popover__main"
                  onClick={() => { onApply(v.id); setOpen(false); }}
                >
                  {v.name}
                </button>
                {onDelete ? (
                  <button
                    type="button"
                    className="lex-popover__del"
                    aria-label={`Delete view ${v.name}`}
                    onClick={() => onDelete(v.id)}
                  >×</button>
                ) : null}
              </div>
            ))}
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="New view name"
                aria-label="New view name"
                style={{
                  flex: 1, padding: "6px 10px", border: "1px solid var(--md-outline-var)",
                  borderRadius: "var(--r-pill)", background: "var(--md-sc-lowest)",
                  font: "var(--t-body-sm)",
                }}
              />
              <button
                type="button"
                className="lex-popover__cta"
                disabled={!name.trim()}
                onClick={() => { if (name.trim()) { onSave(name.trim()); setName(""); setOpen(false); } }}
              >Save</button>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default SavedViews;
